import { getApi } from '../api';

/**
 * PATCH /api/v2/accounts/{account}/shipments/{shipment}/routes/{routeId}
 */
export default async function patchAccountShipmentRouteSegment(
  accountId: number,
  shipmentId: number,
  routeId: number,
  segment: Record<string, unknown>,
): Promise<void> {
  const { api, baseURL } = getApi();
  await api.patch(
    `/api/v2/accounts/${accountId}/shipments/${shipmentId}/routes/${routeId}`,
    segment,
    { baseURL },
  );
}
